import { createFileRoute } from "@tanstack/react-router";
import { canonical } from "@/components/site/site-config";
import { PageHero, ServicePageBody } from "@/components/site/PageShell";
import { BUSINESS } from "@/components/site/constants";

export const Route = createFileRoute("/gutters")({
  head: () => ({
    meta: [
      { title: "Gutter Installation & Repair in Citrus County, FL | Destination Roofing" },
      { name: "description", content: `Seamless gutter installation and gutter repair in Citrus County, FL. Free Roof Inspection & Estimate. Call ${BUSINESS.phone}.` },
      { property: "og:title", content: "Gutter Installation & Repair in Citrus County, FL" },
      { property: "og:description", content: "Seamless gutters and gutter repair in Citrus County, FL." },
      { property: "og:url", content: canonical("/gutters") },
    ],
    links: [{ rel: "canonical", href: canonical("/gutters") }],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <PageHero showRating
        eyebrow="Gutters"
        title="Seamless gutters in Citrus County, FL"
        subtitle="Good gutters protect your soffit, siding, foundation, and landscaping. Bad gutters cause slow, expensive damage that sneaks up on you."
      />
      <ServicePageBody title="Gutters" service="Gutters">
        <h2>Seamless aluminum gutters</h2>
        <p>
          We install seamless aluminum gutters custom-formed on-site to your home's exact runs. Fewer seams means fewer leaks, and a cleaner look along your roofline. We match color to your fascia and trim so the gutters look built-in, not bolted on.
        </p>

        <h2>Common gutter problems we fix</h2>
        <ul>
          <li>Overflowing gutters during heavy Florida rain</li>
          <li>Sagging or pulled-away sections</li>
          <li>Leaks at seams, corners, and downspout outlets</li>
          <li>Water pouring behind gutters and rotting fascia or soffit</li>
          <li>Downspouts that dump water against your foundation</li>
        </ul>

        <h2>Gutter guards</h2>
        <p>
          If you've got trees near your roofline, gutter guards will save you hours of ladder work every year. Ask us during your Free Roof Inspection & Estimate.
        </p>
      </ServicePageBody>
    </>
  );
}
